import angular from 'angular';

let ServiceListController = function ($filter, $mdDialog, $scope, $state, Service, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit, orderList, showCreateDialog, handleDelete
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'name ASC',
      like_search: '',
      like_search_fields: [
        'name'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function edit(event, service) {
    showCreateDialog(event, service);
  }

  function handleDelete(resource, event) {
    event.stopPropagation();

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('common-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('common-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Service
          .destroy(resource)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.deleting = false;
            _.remove($ctrl.resources.data, resource);
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];

      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;
      } else {
        tableConfig.order = field + ' ' + 'ASC';
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  function showCreateDialog(event, selectedService) {
    $ctrl.selectedService = selectedService;

    let contentText = '\'service-list-create-dialog-content\'';
    let title = selectedService ? '\'common-edit\'' : '\'common-new-masculine\'';

    let dialog = {
      controller: DialogController,
      targetEvent: event,
      template:
      '<md-dialog aria-label="List dialog">' +
      '  <form name="form" ng-cloak ng-submit="saveResource(service)">' +
      '  <md-dialog-content class="layout-padding">'+
      '  <div class="md-dialog-content" >'+
      '    <h2>{{ ' + title + ' | translate }}</h2>'+
      '' +
      '    <p>{{'+ contentText + '| translate }}</p>'+
      '' +
      '<br>' +
      '    <md-input-container class="md-block" flex>'+
      '      <label>{{ \'common-name\' | translate }}</label>'+
      '' +
      '      <input ng-model="service.name" required>'+
      '    </md-input-container>' +
      '    </div>' +
      '    </md-dialog-content>' +
      '  <md-dialog-actions>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false
    };

    // if (false) {
    //   dialog.template += '' +
    //   '    <md-button ng-click="cancel()" class="md-raised md-warn">' +
    //   '      {{ \'common-delete\' | translate }}' +
    //   '    </md-button>' +
    //   '' +
    //   '    <span style="width: 100px;"></span>';
    // }

    dialog.template += '' +
    '    <md-button ng-click="cancel()">' +
    '      {{ \'common-cancel\' | translate }}' +
    '    </md-button>' +
    '' +
    '    <md-button type="submit"' +
    '               ng-disabled="!form.$valid" class="md-accent">' +
    '      {{ \'common-save-button-text\' | translate }}' +
    '    </md-button>' +
    '  </md-dialog-actions>' +
    '  </form>' +
    '</md-dialog>';

    $mdDialog.show(dialog)
          .then((service) => {
            if (selectedService) {
              service = angular.extend(selectedService, service);
            }

            save(service);
          }, () => {});
  }

  function DialogController($scope, $mdDialog) {
    "ngInject";

    $scope.service = angular.copy($ctrl.selectedService) || {};

    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.saveResource = function(service) {
      $mdDialog.hide(service);
    };

    $scope.deleteResource = function(service) {
      // $mdDialog.hide(service);
    }
  }

  // Local functions

  function loadData() {
    angular.extend($ctrl.$scope.tableConfig, $state.params);

    $ctrl.promise = Service
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
    _.forEach(arr, item => {
      if (item.description === null || item.description === undefined) {
        item.description = $filter('translate')('common-not-informed');
      }
    });
  }

  function save(service) {
    $ctrl.promise = Service
      .save(service)
      .then(response => {
        loadData();
        Toast.success($filter('translate')('service-detail-save-success'));
      })
      .catch(err => {
        loadData();
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'service-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
      });
  }
}

ServiceListController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Service', 'Toast'];

export default ServiceListController;



// WEBPACK FOOTER //
// ./client/app/components/service/service-list.controller.js